module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/124.2a7844e0.svg";